import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SocialBar from "./SocialBar";

/**
 * Wraps every public marketing page with:
 *  – Announcement bar (scrolling brand strip + onboarding CTA + contact)
 *  – Glass navbar
 *  – Dark blue/purple background + noise overlay (via .mkt-shell CSS)
 *  – Floating social bar with premium "Official OMS Partner of Myntra"
 *    badge tail directly under the WhatsApp icon
 *  – Footer
 *
 * Functional pages (dashboard, login, admin) are NOT wrapped → keep their existing theme.
 */
export default function MarketingShell({ children, onBookDemo, hideFooter = false }) {
  return (
    <div className="mkt-shell">
      <Navbar onBookDemo={onBookDemo} />
      <SocialBar />
      <main>{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
